module.exports = __webpack_public_path__ + "69b4872aeb1b83e669b12617ec1ebd14.svg";